/* @flow */
import { parse as parseUrl } from 'url';

const CLICKTRACKER_REGEX = /ad\.doubleclick\.net/;
// .uk and .de remain in here so that they get tracked in GA as "Internal Link"s
const INTERNAL_HOSTNAME_REGEX = /www\.refinery29\.(com|uk|de)|www\.[a-z0-9\-_\.]+\.rf29.net/; // eslint-disable-line no-useless-escape
const RELATIVE_LINK_REGEX = /^\//;
const MAILTO_REGEX = /^mailto/;
const SLIDE_REGEX = /#slide-\d+$/;

export const isClickTrackerLink = (href: string): bool =>
  CLICKTRACKER_REGEX.test(href);

export const isMailtoLink = (href: string): bool =>
  MAILTO_REGEX.test(href);

export const isSlideLink = (href: string): bool =>
  SLIDE_REGEX.test(href);

export const isInternalLink = (href: string): bool => {
  if (RELATIVE_LINK_REGEX.test(href)) {
    return true;
  }

  const { hostname } = parseUrl(href);
  if (hostname && INTERNAL_HOSTNAME_REGEX.test(hostname)) {
    return true;
  }

  return false;
};
